
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class OrderInstallmentReportDialog extends Serenity.EntityDialog<OrderInstallmentReportRow, any> {
        protected getFormKey() { return OrderInstallmentReportForm.formKey; }
        protected getIdProperty() { return OrderInstallmentReportRow.idProperty; }
        protected getLocalTextPrefix() { return OrderInstallmentReportRow.localTextPrefix; }
        protected getNameProperty() { return OrderInstallmentReportRow.nameProperty; }
        protected getService() { return OrderInstallmentReportService.baseUrl; }
        protected getDeletePermission() { return OrderInstallmentReportRow.deletePermission; }
        protected getInsertPermission() { return OrderInstallmentReportRow.insertPermission; }
        protected getUpdatePermission() { return OrderInstallmentReportRow.updatePermission; }

        protected form = new OrderInstallmentReportForm(this.idPrefix);

    }
}